/**
 * Возвращает высоту DOM-элемента, если он существует, иначе 0.
 * Используется для безопасного расчета вертикальных отступов.
 */
export const getElementHeight = (el?: HTMLElement | null): number => el?.offsetHeight ?? 0;
